module.exports = __webpack_public_path__ + "images/cross7b5d96caecc05ad67208e3ddfb15b297.svg";